import { FullProject, projectStatusByCode, taskStatusByCode, taskStatusesConfig } from 'entities';

import { Tag, Tooltip } from 'components/Blocks';
import { CalendarRangeIcon } from 'components/Icons';

import { getShortDayMonth } from 'utils/date';
import { getTaskDateColor, getTaskDaysLeft } from '../utils';
import { useProjectProfile } from '../../context';

type TaskDeadlineProps = {
  task: FullProject['tasks'][number];
  className: string;
};

export function TaskDeadline({ task, className }: TaskDeadlineProps) {
  const { project } = useProjectProfile();

  const expectedDate = task?.expectedDate;

  if (!expectedDate || task.status === taskStatusesConfig.canceled.code) return null;

  const daysLeft = getTaskDaysLeft(expectedDate);

  const color = getTaskDateColor(expectedDate);

  const { isActiveStatus } = projectStatusByCode[project.status];
  const taskConfig = taskStatusByCode[task.status];

  const isActive = isActiveStatus && taskConfig.isActiveStatus;

  return (
    <div className={className}>
      <Tooltip ensurePresence disabled={!isActiveStatus} content={`${daysLeft} days left`}>
        <Tag
          round={false}
          color={isActive ? color : 'muted-foreground'}
          size="medium"
          type="outlined"
          name={
            <>
              <CalendarRangeIcon size={14} />
              {getShortDayMonth(expectedDate)}
            </>
          }
        />
      </Tooltip>
    </div>
  );
}
